const Data = {
  'Básico': 
    {
      A: { module1: 'bolillo',    module2: 'murphy',      module3: 'cajonera',    module4: 'escritorio' },
      B: { module1: 'bolillo',    module2: 'murphy',      module3: 'escritorio',  module4: 'cocina'     },
      C: { module1: 'escritorio', module2: 'murphy',      module3: 'bolillo',     module4: 'cocina'     },
      D: { module1: 'bolillo',    module2: 'cajonera',    module3: 'murphy',      module4: 'escritorio' },
      E: { module1: 'escritorio', module2: 'bolillo',     module3: 'murphy',      module4: 'cajonera'   },
      F: { module1: 'bolillo',    module2: 'escritorio',  module3: 'murphy',      module4: 'cajonera'   },
    },
  'Liviano': {
      G: { module1: '', module2: '' },
      H: { module1: '', module2: '' },
    },
  'ObraGris': {

    },
}

module.exports = { Data };